import { FC } from 'react';
import { Box, Text, TextProps } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './TemplateCountDisplay.module.scss';
import useTemplateSearchField from '@components/Templates/TemplateSearchField/useTemplateSearchField';

interface Props {
  templateCount?: number;
}

const TemplateCountDisplay: FC<Props> = ({ templateCount }) => {
  const { t } = useTranslation();
  const { isSearchEnabled } = useTemplateSearchField();

  if (!Number.isInteger(templateCount)) {
    return <Box />;
  }

  const text = isSearchEnabled
    ? t('marketplace.templates-page.template-count.studio-short', {
        count: templateCount,
      })
    : t('marketplace.templates-page.template-count.studio', {
        count: templateCount,
      });

  const weight = 'thin';
  const props = {
    className: s.coloredText,
    weight,
  } as TextProps;

  return (
    <Box>
      <Text {...props}>{text}</Text>
    </Box>
  );
};

export default TemplateCountDisplay;
